import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './ui/App'
import * as serviceWorker from './serviceWorker'

// Import i18n (needs to be bundled ;)) (Ugly i18next)
import './utils/i18'

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
